<template>
  <div class="vipBox" v-if="rawData || errorMsg" @click="clickAll">
    <div class="outSideBox">
      <div class="contentBox">
        <div class="titleBox">
          <img
            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/vipIcon.png"
            alt=""
            class="takeTaxiIcon"
          />
          <div class="titleText">出行+会员</div>
        </div>
        <!-- 会员信息 -->
        <div
          class="type1"
          v-if="rawData.status == '1'"
          :class="{ isExpire: isExpire }"
        >
          <div class="userName">{{ rawData.nickname }}</div>
          <div class="line1">
            <span class="span">{{ formatDate(rawData.expireTime) }}到期</span>
            <span class="span">剩余{{ rawData.expireDays }}天</span>
          </div>
          <div class="line2">已享受会员权益{{ rawData.totalDays }}天</div>
          <div class="line3">
            <div class="div">
              <span class="text">累计已省</span>
              <span class="price"
                >{{ rawData.totalDiscountAmount / 100 }}元</span
              >
            </div>
            <div class="div">
              <span class="text">本期已省</span>
              <span class="price"
                >{{ rawData.currentDiscountAmount / 100 }}元</span
              >
            </div>
          </div>
        </div>
        <div
          class="type2"
          v-if="rawData.status == '0'"
          :class="{ isExpire: isExpire }"
        >
          <div class="tabBarBox">
            <div
              class="tabBarItem"
              :class="{ tabBarItem_active: activeIndex == key }"
              v-for="(value, key) in rawData.memberOpenImage"
              :key="key"
              @click="clickChangeActiveIndex(key)"
            >
              <span class="tabBarItemName">{{ value.title }}</span>
              <div class="bottomLine"></div>
            </div>
          </div>
          <div class="imgBox">
            <img
              class="img"
              :src="rawData.memberOpenImage[activeIndex].image"
              alt=""
            />
          </div>
          <div class="openVipBtnBox" @click="clickOpenVipBtn">
            <div class="openVipBtn">开通会员</div>
          </div>
        </div>
        <!-- 错误信息 -->
        <div
          class="errorMsgBox"
          v-if="errorMsg != ''"
          :class="{ isExpire: isExpire }"
        >
          {{ errorMsg }}
        </div>
        <div
          @click="clickOpenVipBtn"
          class="bottomBar"
          v-if="errorMsg != '' || rawData.status == '1'"
          :class="{ isExpire: isExpire }"
        >
          <div class="moreBox">
            <div class="text">查看更多</div>
            <img
              class="right_arrow_gray"
              src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/right_arrow_gray.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const config = {
  dxlc: {
    test: "https://lzgj.test.brightcns.cn/benefits/",
    prod: "https://h5-lzgj.brightcns.com/benefits/",
  },
};
const env = process.env.VUE_APP_ENV;
export default {
  data: function () {
    return {
      isExpire: false,
      timer: null,
      channel: null,
      type: null,
      rawData: null,
      bizReq: null,
      errorMsg: "",
      activeIndex: 0,
    };
  },
  props: ["businessContent"],
  mounted: function () {
    console.log(this.businessContent);
    if (this.businessContent.bizCode == "SUCCESS") {
      this.type = this.businessContent.type;
      this.rawData = JSON.parse(this.businessContent.bizData);
      this.channel = this.businessContent.channel;
    } else {
      this.errorMsg = this.businessContent.bizMsg;
    }
    this.checkIsExpire(this.businessContent);
    console.log(this.rawData);
  },
  methods: {
    // 格式化年月日
    formatDate: function (date) {
      // 时间格式化
      function dateFtt(fmt, date) {
        //author: meizz
        var o = {
          "M+": date.getMonth() + 1, //月份
          "d+": date.getDate(), //日
          "h+": date.getHours(), //小时
          "m+": date.getMinutes(), //分
          "s+": date.getSeconds(), //秒
          "q+": Math.floor((date.getMonth() + 3) / 3), //季度
          S: date.getMilliseconds(), //毫秒
        };
        if (/(y+)/.test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        for (var k in o)
          if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
        return fmt;
      }
      let currentDate = new Date(date.replace(/-/g, "/"));
      return dateFtt("yyyy.MM.dd", currentDate);
    },
    // 点击切换
    clickChangeActiveIndex: function (key) {
      if (this.isExpire) {
        return;
      }
      this.activeIndex = key;
    },
    // 检测卡片是否过期
    checkIsExpire: function (businessContent) {
      let expireTime = new Date(
        businessContent.expireTime.replace(/-/g, "/")
      ).getTime();
      let nowTime = new Date().getTime();
      if (nowTime > expireTime) {
        this.isExpire = true;
      } else {
        console.log("卡片过期时间", expireTime - nowTime);
        this.timer = setTimeout(() => {
          this.isExpire = true;
          clearTimeout(this.timer);
          this.timer = null;
        }, expireTime - nowTime);
      }
    },
    // 点击整个卡片
    clickAll: function () {
      if (this.isExpire) {
        this.$toast("已失效");
        setTimeout(() => {
          this.jumpToH5();
        }, 1000);
      }
    },
    // 点击开通会员
    clickOpenVipBtn: function () {
      if (this.isExpire) {
        return;
      }
      this.jumpToH5();
    },
    // 跳转到会员h5
    jumpToH5: function () {
      let url = config[this.businessContent.channel][env];
      url =
        url +
        `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
          "sessionId"
        )}&target=VipDetailPage`;
      window.location.href = url;
    },
  },
  destroyed: function () {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./vipBox.scss";
</style>
